import React from 'react';
import fullSchema from 'vets-json-schema/dist/21-526EZ-ALLCLAIMS-schema.json';
import dateUI from '@department-of-veterans-affairs/platform-forms-system/date';
import { validateDateRange } from '@department-of-veterans-affairs/platform-forms-system/validation';
import { ReservesGuardDescription } from '../utils';
import { createAllowedCharValidator } from '../validations';

const {
  properties: { obligationTermOfServiceDateRange, unitName },
  required,
} =
  fullSchema.properties.serviceInformation.properties
    .reservesNationalGuardService;

export const uiSchema = {
  'ui:title': (
    <h3 className="vads-u-margin-y--0">
      Reserve and National Guard information
    </h3>
  ),
  'ui:description': ReservesGuardDescription,
  serviceInformation: {
    reservesNationalGuardService: {
      obligationTermOfServiceDateRange: {
        'ui:validations': [validateDateRange],
        'ui:errorMessages': {
          pattern: 'End date must be after start date',
          required: 'Please enter a date',
        },
        from: dateUI('Obligation start date'),
        to: dateUI('Obligation end date'),
      },
      unitName: {
        'ui:title': 'Unit name',
        'ui:validations': [
          createAllowedCharValidator(unitName.pattern, 'unit name'),
        ],
      },
    },
  },
};

export const schema = {
  type: 'object',
  properties: {
    serviceInformation: {
      type: 'object',
      properties: {
        reservesNationalGuardService: {
          type: 'object',
          required,
          properties: {
            obligationTermOfServiceDateRange,
            unitName: {
              type: 'string',
              maxLength: 256,
            },
          },
        },
      },
    },
  },
};
